import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

import './App.css';
import './common/common.css';

import Header from './common/Header';
import FirstPage from './first-page/FirstPage';
import SecondPage from './second-page/SecondPage';
import ThirdPage from './third-page/ThirdPage';

import rootReducer from './reducers';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Header></Header>
            <Route exact path="/" component={FirstPage} />
            <Route path="/category/:id" component={SecondPage} />
            <Route path={`/table/:cat/:subcat`} component={ThirdPage}/>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
